import React, { createContext, useContext, useMemo, useEffect } from 'react'
import { DeviceDetectionService } from '@/utils/DeviceDetectionService'

interface DeviceContextType {
  isIPad: boolean
  isTouchDevice: boolean
}

const DeviceContext = createContext<DeviceContextType>({
  isIPad: false,
  isTouchDevice: false,
})

export const DeviceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const deviceInfo = useMemo(
    () => ({
      isIPad: DeviceDetectionService.isIPadOS(),
      isTouchDevice: DeviceDetectionService.isTouchDevice(),
    }),
    []
  )

  useEffect(() => {
    if (deviceInfo.isIPad) {
      document.body.classList.add('ipad-device')
    }
    return () => {
      document.body.classList.remove('ipad-device')
    }
  }, [deviceInfo.isIPad])

  return <DeviceContext.Provider value={deviceInfo}>{children}</DeviceContext.Provider>
}

export const useDevice = (): DeviceContextType => useContext(DeviceContext)
